// extracted by mini-css-extract-plugin
module.exports = {"container":"LabelsMultiSelect_container__2NS3T","selectContainer":"LabelsMultiSelect_selectContainer__2w78K","option":"LabelsMultiSelect_option__3j8po"};